import { render, staticRenderFns } from "./TotalsIndicator.vue?vue&type=template&id=091e73df&scoped=true"
import script from "./TotalsIndicator.vue?vue&type=script&lang=js"
export * from "./TotalsIndicator.vue?vue&type=script&lang=js"
import style0 from "./TotalsIndicator.vue?vue&type=style&index=0&id=091e73df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091e73df",
  null
  
)

export default component.exports